import React__default, { useRef } from 'react';
import './Badge.scss.js';

var Badge = function Badge(_ref) {
  var badgeContent = _ref.badgeContent,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'info' : _ref$variant,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 99 : _ref$max,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? true : _ref$display,
      _ref$placeNear = _ref.placeNear,
      placeNear = _ref$placeNear === void 0 ? false : _ref$placeNear,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      contentStyle = _ref.contentStyle;
  var wrapper = useRef(null);
  var isDot = badgeContent ? '' : "rf-badge--dot--".concat(size); // -------------------------------------------------------------------------------------------------------------------

  var textClass = typeof children === 'string' ? 'rf-badge--text' : '';
  var placeNearClass = placeNear ? 'rf-badge--near' : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: "rf-badge__wrapper ".concat(className, " ").concat(placeNearClass),
    ref: wrapper,
    "data-v-6e52f9c7": ""
  }, children, display && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-badge badge-size--".concat(size, " rf-badge--").concat(variant, " ").concat(isDot, " ").concat(textClass),
    style: contentStyle,
    "data-v-6e52f9c7": ""
  }, badgeContent ? !isNaN(+badgeContent) && +badgeContent > max ? "".concat(max, "+") : badgeContent : null));
};

export { Badge as default };
